import React from 'react';
import cx from 'classnames';
import MicSlash from '../../../../images/icons/iconMicOFF.svg';
import './StudentMicProgressView.scss';

/**
 * StudentMicProgressView component displays a mic icon during the ASR check.
 * Shows a green animated mic when listening, and a gray muted mic when paused.
 * 
 * @param {Object} props - Component props.
 * @param {boolean} props.isListening - Whether the app is currently listening for speech.
 */
export default function StudentMicProgressView(props) {
  const { isListening } = props;

  const containerClassNames = cx('student-mic-progress-view__mic-container', {
    'student-mic-progress-view__mic-container--paused': !isListening
  });

  return (
    <div className="student-mic-progress-view">
      <div className="student-mic-progress-view__content">
        <div className={containerClassNames}>
          {isListening ? (
            // Green animated microphone icon (SVG)
            <svg 
              className="student-mic-progress-view__mic-icon"
              xmlns="http://www.w3.org/2000/svg" 
              width="100" 
              height="140" 
              viewBox="0 0 69 99" 
              fill="none"
            >
              <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M34.5 69.1824C45.1361 69.1824 53.7857 60.3705 53.7857 49.546H42.6818C40.9873 49.546 39.6136 48.1723 39.6136 46.4778C39.6136 44.7833 40.9873 43.4096 42.6818 43.4096H53.7857V37.2733H42.6818C40.9873 37.2733 39.6136 35.8996 39.6136 34.2051C39.6136 32.5106 40.9873 31.1369 42.6818 31.1369H53.7857V25.0005H42.6818C40.9873 25.0005 39.6136 23.6269 39.6136 21.9324C39.6136 20.2378 40.9873 18.8642 42.6818 18.8642H53.7485C53.1245 8.6044 44.7313 0.455078 34.5 0.455078C24.2687 0.455078 15.8755 8.6044 15.2515 18.8642H26.3182C28.0127 18.8642 29.3864 20.2378 29.3864 21.9324C29.3864 23.6269 28.0127 25.0005 26.3182 25.0005H15.2143V31.1369H26.3182C28.0127 31.1369 29.3864 32.5106 29.3864 34.2051C29.3864 35.8996 28.0127 37.2733 26.3182 37.2733H15.2143V43.4096H26.3182C28.0127 43.4096 29.3864 44.7833 29.3864 46.4778C29.3864 48.1723 28.0127 49.546 26.3182 49.546H15.2143C15.2143 60.3705 23.8639 69.1824 34.5 69.1824ZM68.25 49.546V39.7278C68.25 38.4258 67.742 37.1772 66.8379 36.2566C65.9337 35.3359 64.7073 34.8187 63.4286 34.8187C62.1499 34.8187 60.9235 35.3359 60.0193 36.2566C59.1151 37.1772 58.6072 38.4258 58.6072 39.7278V49.546C58.6072 63.0804 47.7927 74.0914 34.5 74.0914C21.2073 74.0914 10.3929 63.0804 10.3929 49.546V39.7278C10.3929 38.4258 9.88489 37.1772 8.98069 36.2566C8.0765 35.3359 6.85015 34.8187 5.57143 34.8187C4.29271 34.8187 3.06636 35.3359 2.16216 36.2566C1.25797 37.1772 0.75 38.4258 0.75 39.7278V49.546C0.75 66.826 13.3484 81.1213 29.6786 83.5169V88.8187H15.2143C13.9356 88.8187 12.7092 89.3359 11.805 90.2566C10.9008 91.1772 10.3929 92.4258 10.3929 93.7278C10.3929 95.0298 10.9008 96.2784 11.805 97.1991C12.7092 98.1197 13.9356 98.6369 15.2143 98.6369H53.7857C55.0644 98.6369 56.2908 98.1197 57.195 97.1991C58.0992 96.2784 58.6072 95.0298 58.6072 93.7278C58.6072 92.4258 58.0992 91.1772 57.195 90.2566C56.2908 89.3359 55.0644 88.8187 53.7857 88.8187H39.3214V83.5169C55.6516 81.1213 68.25 66.826 68.25 49.546Z" 
                fill="#00A56F"
              />
            </svg>
          ) : (
            // Muted microphone icon (same as ReactiveListeningStatus inactive state)
            <img 
              className="student-mic-progress-view__mic-icon student-mic-progress-view__mic-icon--inactive"
              src={MicSlash}
              alt="Microphone muted"
            />
          )}
        </div>
      </div>
    </div>
  );
}
